import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Invoice, InvoiceSearchParams, InvoiceSearchResults } from 'src/app/shared/models/financials/invoice';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../error/error.service';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class InvoicesApiService extends ApiBaseService {

	baseUrl = environment.backend_host + '/api/invoices';

	constructor(
		public http: HttpClient,
		protected spinner: NgxSpinnerService,
		protected error: ErrorService
	) {
		super(spinner, error);
	}

	public getInvoices = (params: InvoiceSearchParams): Observable<InvoiceSearchResults> => {
		const p = this.serializeParamsObj(params, new HttpParams());
		return this.http.get<any>(`${this.baseUrl}/`, { params: p })
			.pipe(map(this.deserializeAs(InvoiceSearchResults)));
	}

	public createInvoice = (invoice: Invoice): Observable<Invoice> => {
        return this.http.post<any>(`${this.baseUrl}/`, this.serialize(invoice))
            .pipe(map(this.deserializeAs(Invoice)));
    }

	public getInvoice = (id): Observable<Invoice> => {
		return this.http.get<any>(`${this.baseUrl}/${id}`)
			.pipe(map(this.deserializeAs(Invoice)));
	}

	public updateInvoice = (invoice: Invoice): Observable<Invoice> => {
		return this.http.put<any>(`${this.baseUrl}/${invoice.id}`, this.serialize(invoice))
			.pipe(map(this.deserializeAs(Invoice)));
	}

	public updateInvoiceStatus = (invoice: Invoice): Observable<Invoice> => {
		return this.http.put<any>(`${this.baseUrl}/${invoice.id}/status`, this.serialize(invoice))
			.pipe(map(this.deserializeAs(Invoice)));
	}
}
